// extracted by mini-css-extract-plugin
export default {"button":"SubmitForm_button__q8OYm"};